import { z } from 'zod';

export const AftCandidateEngagementsHistorySearchResponseMetaSchema = z.object({
  currentPage: z.number().nonnegative().int(),
  pageCount: z.number().nonnegative().int(),
  resultCount: z.number().nonnegative().int(),
});

export type AftCandidateEngagementsHistorySearchResponseMeta = z.infer<
  typeof AftCandidateEngagementsHistorySearchResponseMetaSchema
>;
